import Gleap from 'gleap'
import { identityVerificationGleap } from '../helpers/AuthHelper'

/**
 * On Gleap side we use the same project for staging/production environments.
 * To avoid users mixing up between environments, we add the environment name as a prefix to the user id.
 */

const GleapIdentify = (user: { id: number; name: string; email: string }) => {
  identityVerificationGleap().then((response) => {
    const hash = response.data?.data?.hash
    if (!hash) return
    Gleap.identify(
      `${process.env.REACT_APP_ENVIRONMENT}-${user.id}`,
      {
        name: user.name,
        email: user.email,
      },
      hash
    )
  })
}

const GleapRedactUser = () => {
  Gleap.updateContact({
    name: 'DELETED ACCOUNT',
    email: 'DELETED ACCOUNT',
  })
  Gleap.clearIdentity()
}

export { GleapIdentify, GleapRedactUser }
